<div
  class="Notification"
  @fade
  [ngClass]="{
    'Notification--IsUnread': !notification.is_read,
    'Notification--IsOpen': isNotificationOpen,
  }"
>
  <div class="Notification__Timestamp u-flex u-justifyBetween">
    <span>
      <span
        class="Notification__Date"
        [innerHTML]="notification.created_at | date: 'mediumDate'"
      ></span>
      <span
        class="Notification__Time"
        [innerHTML]="notification.created_at | date: 'h:mma'"
      ></span>
    </span>
    <icon
      class="Notification__Chevron Notification__Chevron--Mobile"
      name="chevron_down"
      [config]="{
        type: 'pointer',
        transform: isNotificationOpen ? 'rotate180' : null,
      }"
      (click)="toggleNotification(notification)"
    >
    </icon>
  </div>

  <div class="Notification__Body u-flex u-fillRemaining">
    <div class="Notification__Category">
      <icon class="Notification__Icon" [name]="notification.icon"> </icon>
    </div>

    <div class="Notification__Content">
      <div class="Notification__Triangle"></div>

      <div class="Notification__Header">
        <h4
          class="Notification__Title t-data t-bold"
          [innerHTML]="notification.title"
        ></h4>

        <icon
          class="Notification__Chevron Notification__Chevron--Desktop"
          name="chevron_down"
          role="button"
          [attr.aria-controls]="notificationId"
          [attr.aria-expanded]="isNotificationOpen"
          [config]="{
            type: 'pointer',
            transform: isNotificationOpen ? 'rotate180' : null,
          }"
          (click)="toggleNotification(notification)"
        >
        </icon>
      </div>

      @if (isNotificationOpen) {
        <div [id]="notificationId" class="Notification__Body" @accordion>
          <p
            class="Notification__Text t-html"
            [innerHtml]="notification.content"
          ></p>
          <footer class="Notification__Footer">
            <zip-button
              [config]="{
                level: 'text',
                content: 'Delete',
              }"
              (zipButtonClicked)="delete()"
            >
            </zip-button>
          </footer>
        </div>
      }
    </div>
  </div>
</div>
